export const AS_MOTOR_CLAIM_ROUTING_SET_VALUE = "allSureMotorClaim/routing/setValue/";
export const NAVIGATE_PREVIOUS = AS_MOTOR_CLAIM_ROUTING_SET_VALUE + "navigatePrevious";
export const NAVIGATE_NEXT = AS_MOTOR_CLAIM_ROUTING_SET_VALUE + "navigateNext";
export const NAVIGATE_INDEX = AS_MOTOR_CLAIM_ROUTING_SET_VALUE + "navigateIndex";
export const SET_NAVIGATION_DONE = AS_MOTOR_CLAIM_ROUTING_SET_VALUE + "navigationDone";
export const navigatePrevious = () => ({ type: NAVIGATE_PREVIOUS });
export const navigateNext = () => ({ type: NAVIGATE_NEXT });
export const navigateIndex = (value) => ({ type: NAVIGATE_INDEX, value });
export const setNavigationDone = () => ({ type: SET_NAVIGATION_DONE });
export const RESET_ROUTING = "allSureMotorClaim/routing/transition/resetState";
export const resetRouting = () => ({ type: RESET_ROUTING });
export const setCategoryName = (value) => ({ type: CATEGORY, value });


export const SET_ACTIVE_PAGE_INDEX = AS_MOTOR_CLAIM_ROUTING_SET_VALUE + "activePageIndex";
export const setActivePageIndex = (value) => ({
  type: SET_ACTIVE_PAGE_INDEX,
  value,
});

// per page transitions
export const ROUTING_TRANSITION = "allSureMotorClaim/routing/transition/";

export const NAVIGATE_TO_CATEGORY_PAGE = ROUTING_TRANSITION + "toCategory";
export const navigateToCategoryPage= () => ({
  type: NAVIGATE_TO_CATEGORY_PAGE,
});

export const NAVIGATE_TO_BASIC_DETAILS = ROUTING_TRANSITION + "toBasicDetails";
export const navigateToBasicDetails = () => ({
  type: NAVIGATE_TO_BASIC_DETAILS,
});

export const NAVIGATE_TO_INCIDENT_DETAILS = ROUTING_TRANSITION + "toIncidentDetails";
export const navigateToIncidentDetails = () => ({
  type: NAVIGATE_TO_INCIDENT_DETAILS,
});

export const NAVIGATE_TO_OTHER_DETAILS = ROUTING_TRANSITION + "toOtherDetails";
export const navigateToOtherDetails = () => ({
  type: NAVIGATE_TO_OTHER_DETAILS,
});

export const NAVIGATE_TO_UPLOAD_DOCUMENTS = ROUTING_TRANSITION + "toUploadDocuments";
export const navigateToUploadDocuments = () => ({
  type: NAVIGATE_TO_UPLOAD_DOCUMENTS,
});

export const NAVIGATE_TO_CONFIRMATION = ROUTING_TRANSITION + "toConfirmation";
export const navigateToConfirmation = () => ({
  type: NAVIGATE_TO_CONFIRMATION,
});

export const NAVIGATE_TO_SUCCESS_PAGE = ROUTING_TRANSITION + "toSuccess";
export const navigateToSuccessPage = () => ({ type: NAVIGATE_TO_SUCCESS_PAGE });

export const SCROLL_TO_CLASS = 'allSureMotorClaim/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'allSureMotorClaim/scrolling/transition/scrollToId';
export const CLEAR_SCROLL = 'allSureMotorClaim/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value}),
    scrollToId: (value) => ({type: SCROLL_TO_ID, value}),
}
export const resetScroll = () => ({ type: CLEAR_SCROLL });